import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { StudiesService } from '../studies.service';
import { ColumnsConfig, TableConfig } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { CommonService } from 'src/app/shared/services/common.service';
import { SitesService } from 'src/app/sites/sites.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';

@Component({
	selector: 'app-studies-inventory',
	templateUrl: './studies-inventory.component.html',
	styleUrls: ['./studies-inventory.component.css']
})
export class StudiesInventoryComponent implements OnInit {

	@ViewChild('locationModal') locationModal: ModalComponent;

	inventoryData: any[] = [];
	selectedLocation: any = null;
	isShownMap: boolean = false;

	listingColumns: ColumnsConfig[] = [];

	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: true,
		pageSize: 100,
		fileName: this.translateService.instant('studies.inventory_report_title'),
		draggable: true,
	};

	constructor(
		private studiesService: StudiesService,
		private translateService: TranslateService,
		private commonService: CommonService,
		public sitesService: SitesService,
	) {}

	ngOnInit() {
		this.listingColumns = this.getListingColumns();
		this.getData();
	}

	getListingColumns(): ColumnsConfig[] {
		return [
			{ key: 'serial_number', name: this.translateService.instant('studies.iotah_ps_sn'), type: 'link' },
			{ key: 'truck_id', name: this.translateService.instant('studies.iotah_ps_id'), type: 'link', noValueString: '-' },
			{ key: 'fw_version', name: this.translateService.instant('studies.inventory_fw_version'), type: 'string', noValueString: '-' },
			{ key: 'first_use_date_fmt', name: this.translateService.instant('studies.inventory_first_use_date'), type: 'date', noValueString: '-' },
			{ key: 'completed_studies_count', name: this.translateService.instant('studies.inventory_completed_studies'), type: 'number' },
			{ key: 'last_connect_time_fmt', name: `${this.translateService.instant('studies.last_connect_time')} (${this.commonService.showUserTimeZoneReference()})`, type: 'date', noValueString: '-' },
			{ key: 'last_connected_in', name: this.translateService.instant('studies.last_connected_in'), type: 'string', noValueString: '-' },
			{ key: 'last_latitude', name: this.translateService.instant('studies.last_lat'), type: 'action_link', noValueString: '-', hasSort: false, hasFilter: false },
			{ key: 'last_longitude', name: this.translateService.instant('studies.last_lon'), type: 'action_link', noValueString: '-', hasSort: false, hasFilter: false },
		];
	}

	getData() {
		this.studiesService.getInventoryReport().subscribe((res: any) => {
			this.inventoryData = this.formatData(res);
		});
	}

	formatData(devices: any[]): any[] {
		return devices.map(device => {
			const deviceLink = (device.customer_id && device.site_id && device.mac_address)
				? ['/', device.customer_id, device.site_id, device.mac_address, 'performance']
				: null;

			return {
				serial_number: { value: device.serial_number, link: deviceLink },
				truck_id: { value: device.truck_id, link: device.truck_id ? deviceLink : null },
				fw_version: { value: device.fw_version },
				first_use_date_fmt: { value: device.first_use_date ? moment(device.first_use_date * 1000).utc().format('YYYY-MM-DD') : null },
				completed_studies_count: { value: device.completed_studies_count },
				last_connect_time_fmt: { value: device.last_connect_time ? moment(device.last_connect_time * 1000).format('YYYY-MM-DD HH:mm') : null },
				last_connected_in: {value: this.commonService.getLastConnectedIn(device.last_connect_time || 0), sortValue: moment().utc().unix() - +(device.last_connect_time || 0) },
				last_latitude: device.last_latitude ? { value: device.last_latitude, action: () => this.openLocationModal(device) } : { value: null },
				last_longitude: device.last_longitude ? { value: device.last_longitude, action: () => this.openLocationModal(device) } : { value: null },
				_device: device,
			};
		});
	}

	openLocationModal(device: any) {
		if (!device.last_latitude || !device.last_longitude)
			return;

		this.isShownMap = false;
		this.selectedLocation = [{
			latitude: device.last_latitude,
			longitude: device.last_longitude,
			type: 'device',
			serial_number: device.serial_number,
			mac_address: device.mac_address,
			sct_device_type: device.sct_device_type,
		}];

		this.locationModal.show();
		setTimeout(() => { this.isShownMap = true; }, 0);
	}
}
